import fetch from 'whatwg-fetch'; // eslint-disable-line no-unused-vars
import Config from '../../../config';
let config;
import queryString from 'query-string';
import {
  createPostRequest,
  createGetRequest,
  injectSessionKey
} from 'lib/tessitura/common/helpers';

/**
 * Create a Request object for GET methods
 *
 * GET with JSONRPC is really awkward.
 * - Content-Type is set to application/json to avoid pre-flight request.
 * - 'id' and 'method' keys are passed as query parameters.
 * - Request Body params need to be Base64 encoded.
 */
function createDeleteRequest(endpoint, sessionKey, body) {
  config = new Config().getConfig();
  const reqBody = injectSessionKey(body, sessionKey);
  let params;

  if (config.api_mode === 'SOAP') {
    params = queryString.stringify(reqBody.params);
  } else {
    params = queryString.stringify(body.params);
  }

  let url = `${endpoint}/${body.method}`;

  if (params) {
    url = `${url}?${params}`;
  }

  return new Request(url, {
    method: 'DELETE',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  });
}

/**
 * Create a Request object for PUT methods
 * - Content-Type is set to application/json to avoid pre-flight request.
 * - Body must be stringified.
 */
function createPutRequest(endpoint, sessionKey, body) {
  config = new Config().getConfig();
  const reqBody = injectSessionKey(body, sessionKey);
  let url = `${endpoint}/${body.method}`;
  let params;

  if (config.api_mode === 'SOAP') {
    params = queryString.stringify(reqBody.params);
  }

  if (params) {
    url = `${url}?${params}`;
  }

  return new Request(url, {
    method: 'PUT',
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(body.params)
  });
}

class API {
  constructor(endpoint, initialSessionKey) {
    this.endpoint = '';
    this.sessionKeyProp = 'sessionkey';
    this.initialSessionKey = initialSessionKey || false;
  }
  fetchNewSessionKey() {
    return Promise.resolve(
      'b75415c136c811ea80c21402ec316fc300000000000000000000000000000000'
    );
  }
  getSessionKey() {
    /**
     * If we have already been passed a session to use
     * in the constructor then use that, or if we have
     * one in localStorage use that otherwise go and
     * fetch a new anonymous session key and store
     * *that* value in localStorage.
     */
    if (this.initialSessionKey) {
      return Promise.resolve(this.initialSessionKey);
    }

    let sessionKey;
    try {
      sessionKey = localStorage.getItem(this.sessionKeyProp);
      sessionKey = JSON.parse(sessionKey);
    } catch (e) {} // eslint-disable-line no-empty

    if (sessionKey) {
      return Promise.resolve(sessionKey);
    } else {
      return new Promise(resolve => {
        this.fetchNewSessionKey().then(newSessionKey => {
          if (!sessionKey) {
            try {
              sessionKey = localStorage.setItem(
                this.sessionKeyProp,
                JSON.stringify(newSessionKey)
              );
            } catch (e) {
              console.log(e);
            } // eslint-disable-line no-empty
          }
          resolve(newSessionKey);
        });
      });
    }
  }
  request(body) {
    return this.getSessionKey().then(sessionKey => {
      let req = createPostRequest(this.endpoint, sessionKey, body);
      return window
        .fetch(req)
        .then(resp => {
          if (resp.status === 400) {
            return resp.json().then(data => {
              return this.throwAPIError(
                req,
                data[0].Description.replace(/^{}+/i, '')
              );
            });
          } else {
            return resp.json();
          }
        })
        .then(resp => {
          return { result: resp };
        })
        .catch(err => this.throwAPIError(req, err));
    });
  }
  requestGet(body) {
    return this.getSessionKey().then(sessionKey => {
      let req = createGetRequest(this.endpoint, sessionKey, body);
      return window
        .fetch(req)
        .then(resp => resp.json())
        .then(resp => {
          return { result: resp };
        })
        .catch(err => this.throwAPIError(req, err));
    });
  }
  requestPut(body) {
    return this.getSessionKey().then(sessionKey => {
      let req = createPutRequest(this.endpoint, sessionKey, body);
      return window
        .fetch(req)
        .then(resp => resp.json())
        .then(resp => {
          return { result: resp };
        })
        .catch(err => this.throwAPIError(req, err));
    });
  }
  requestDelete(body) {
    return this.getSessionKey().then(sessionKey => {
      let req = createDeleteRequest(this.endpoint, sessionKey, body);
      return window
        .fetch(req)
        .then(() => {
          return { result: true };
        })
        .catch(err => this.throwAPIError(req, err));
    });
  }
  throwAPIError(req, error) {
    throw new Error(error);
  }
}

export default API;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/JSONAPI/tessitura-wrapper.js